import { isElementNode } from 'anodum';

export const DISABLE_ATTRIBUTE = 'data-ws-disable';
const DISABLE_ATTRIBUTE_QUERY = '[data-ws-disable]';

const isDisabledNode = (node) =>
  isElementNode(node) && Boolean(node.closest(DISABLE_ATTRIBUTE_QUERY));

const remove = (node) => {
  if (isElementNode(node)) {
    node.removeAttribute(DISABLE_ATTRIBUTE);
  }
};

const removeAll = (node) => {
  const disabledElements = node.querySelectorAll(DISABLE_ATTRIBUTE_QUERY);
  disabledElements.forEach((element) => {
    remove(element);
  });
  remove(node);
  return node;
};

const add = (node) => {
  if (isElementNode(node)) {
    node.setAttribute(DISABLE_ATTRIBUTE, true);
  }
};

export default {
  add,
  remove,
  removeAll,
  isDisabledNode,
};
